export default {"src":"/login-app/[GIT_HASH]/_next/static/media/vertical_align_center.b845debd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};